import API from "@/API";
import store from "@/store";

export const isExpiredReservation = async () => {
  await API.getDbsReservation();
  const reservation = store.getters["dbs/reservation"];
  return reservation.status == "none";
};
